export function setOnPageCount(count) {
    localStorage.setItem('onPageCount', count);
}
export function getOnPageCount() {
    let count = parseInt(localStorage.getItem('onPageCount') ?? 10);
    if (count > 100)
        count = 100;
    return count;
}